import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  ListCard,
  ListCardSubtitle,
  ListCardTitle,
} from '../../../../common/components/cards';
import { styles } from '../../../../common/styles/styles';
import { ExhibitDto } from '../../exhibits.dtos';

interface IProps {
  exhibit: ExhibitDto;
}

const ExhibitListItem: React.FC<IProps> = ({ exhibit }) => {
  const history = useHistory();

  const onClick = () => history.push(`/exhibits/${exhibit.id}`);

  return (
    <ListCard
      // eventClick={() => handleSelectedIndex(index)}
      onClick={onClick}
      title={<ListCardTitle title={exhibit.name} statuses={[]} />}
      subtitles={[
        <ListCardSubtitle
          title={
            exhibit.startDate !== undefined
              ? `${moment(exhibit.startDate).format('MM/DD/YYYY')} - ${moment(
                  exhibit.endDate
                ).format('MM/DD/YYYY')}`
              : ''
          }
          data={exhibit.description}
        />,
      ]}
      actionbutton={
        <FormControlLabel
          value={exhibit.isActive}
          control={
            <Checkbox
              size='small'
              color='primary'
              checked={exhibit.isActive}
              inputProps={{ readOnly: true }}
            />
          }
          label={
            <Typography style={styles.formControlLabel}>Active</Typography>
          }
          labelPlacement='top'
        />
      }
    />
  );
};

export default ExhibitListItem;
